import { Component, OnInit,ViewChild } from '@angular/core';
import { NotifierService } from 'angular-notifier';
import { MatDialog} from '@angular/material/dialog';
import { DataService } from 'src/app/services/data.service';
import {MatTableDataSource} from '@angular/material/table';
import {MatPaginator} from '@angular/material/paginator';
import{ ConfirmListadoIniciativasAdminComponent} from 'src/app/components/shared/confirm-listado-iniciativas-admin/confirm-listado-iniciativas-admin.component';



export interface Motivos {
  id_motivo: number;
  id_tipoMotivo:number;
  nombre_tipoMotivo: string;
  descripcion_motivo: string
}

@Component({
  selector: 'app-motivos-iniciativa',
  templateUrl: './motivos-iniciativa.component.html',
  styleUrls: ['./motivos-iniciativa.component.css']
})
export class MotivosIniciativaComponent implements OnInit {
  listaMotivos:Motivos[]=[];
  displayedColumns: string[] = ['Motivo', 'Tipo', 'Acciones'];
  dataSource:any;
  botonPresionado:number;
  loadingGeneral: boolean = true;
  @ViewChild('TablaMotivos', {static: false}) paginator: MatPaginator;



  constructor(private dataService: DataService,
    public dialog:MatDialog,
    private notifier: NotifierService) { }

  ngOnInit(): void {
    //Cargamos la lista de los motivos
    this.cargarMotivos();
  }

  cargarMotivos()
  {
    this.loadingGeneral = true;
    this.dataService.getListMotivos().subscribe(
      data => {
        this.listaMotivos = data['data'];
        this.dataSource = new MatTableDataSource(this.listaMotivos);
        this.dataSource.paginator=this.paginator;
        this.loadingGeneral = false;
      },
      error => {
        console.error(error);       
      }
    );
  }


    //Método para las acciones de la tabla de periodos
    onSubmitReactive(btnId:number, id_motivo:number,){
      this.botonPresionado=btnId;
      //Opcion de Agregar
      if(this.botonPresionado==1)
      {
         this.agregarMotivo();
      }
  
      //Opcion de Editar
      if(this.botonPresionado==2)
      {
         this.editarMotivo(id_motivo);
      }
  
      //Opcion de Eliminar
      if(this.botonPresionado==3)
      {
         this.eliminarMotivo(id_motivo);
      }
  
    }
   
  //Método para eliminar el motivo
  eliminarMotivo(id_motivo:number)
  {
    //Mostramos la ventana de confirmación
      let dialogRef = this.dialog.open(ConfirmListadoIniciativasAdminComponent,{data:{id_periodo:id_motivo,opcion:16},disableClose:true});
      dialogRef.afterClosed().subscribe(result => {
        if(result==false)
        {
         this.botonPresionado=0;
        }
        else{
         this.dataService.deleteMotivo(id_motivo).subscribe(
           data => {
             if (data['objData']) 
             {
               this.notifier.notify(
                 'success',
                 'Se elimino correctamente.'
               );
               this.cargarMotivos();
               //this.cargarAnteriores();
               //this.zone.run(() => this.router.navigate(['/mis-iniciativas']));
             }
             else{
               this.notifier.notify('error',data['errorMessage']);
             }
           },
           error => {
             console.error(error);
             this.notifier.notify(
               'error',
               'Ha ocurrido un error al intentar eliminar el motivo. Verifique su conexión de red o contacte al administrador.'
             );
           }
         );

         this.botonPresionado=0;
        }
    }); 
  }

  //Agregar motivo
  agregarMotivo()
 { 
    //Mostramos la ventana de confirmación
    let dialogRef = this.dialog.open(ConfirmListadoIniciativasAdminComponent,{data:{opcion:15, titulo:"Agregar motivo de rechazo/suspención/cancelación"},disableClose:true});
    dialogRef.afterClosed().subscribe(result => {
      if(result==false)
      {
       this.botonPresionado=0;
      }
      else{
       this.dataService.addMotivos(result).subscribe(
         data => {
           if (data['objData']) 
           {
             this.notifier.notify(
               'success',
               'Se agrego correctamente.'
             );
             this.cargarMotivos();
           }
           else{
             this.notifier.notify('error',data['errorMessage']);
           }
         },
         error => {
           console.error(error);
           this.notifier.notify(
             'error',
             'Ha ocurrido un error al intentar agregar el motivo. Verifique su conexión de red o contacte al administrador.'
           );
         }
       );
       this.botonPresionado=0;
      }
  }); 
}

//Método para editar motivo
editarMotivo(id__motivo:number)
{
    //Mostramos la ventana de confirmación
    let dialogRef = this.dialog.open(ConfirmListadoIniciativasAdminComponent,{data:{id_motivo:id__motivo,opcion:17,titulo:"Editar motivo"},disableClose:true});
    dialogRef.afterClosed().subscribe(result => {
      if(result==false)
      {
       this.botonPresionado=0;
      }
      else{
       this.dataService.updateMotivo(id__motivo,result).subscribe(
         data => {
           if (data['objData']) 
           {
             this.notifier.notify(
               'success',
               'Se edito correctamente.'
             );
             this.cargarMotivos();
           }
           else{
             this.notifier.notify('error',data['errorMessage']);
              
           }
         },
         error => {
           console.error(error);
           this.notifier.notify(
             'error',
             'Ha ocurrido un error al intentar editar el motivo. Verifique su conexión de red o contacte al administrador.'
           );
         }
       );

       this.botonPresionado=0;
      }
  }); 

}

 //Método para aplicar el filtro 
 applyFilter(event: Event) {
  const filterValue = (event.target as HTMLInputElement).value;
  this.dataSource.filter = filterValue.trim().toLowerCase();
}

}
